import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

@Injectable()
export class ConfigService {
  private appConfig;
  constructor(private injector: Injector) { }

  loadAppConfig() {
    let http = this.injector.get(HttpClient);

    return http
      .get('assets/config/application.json')
      .toPromise()
      .then((data) => {
        this.appConfig = data;
      });
  }

  getBaseUrl() {
    return this.appConfig.apiUrl;
  }

  getShowNotification(): boolean {
    return this.appConfig.showNotification;
  }

  public url = {
    auth: {
      signin: '/api/signin',
      logout: '/api/logout',
      changePassword: '/api/changePassword',
    },
    home: {
      index: '/api/home/index',
    },
    users: {
      index: '/api/users/index',
      getDataPagedList: '/api/users/list',
      getByID: '/api/users/getById',
      create: '/api/users/create',
      update: '/api/users/update',
      delete: '/api/users/delete',
      resetPassword: '/api/users/resetPassword',
      lock: '/api/users/lock',
      export: '/api/users/export',
      import: '/api/users/import',
    },
    functions: {
      index: '/api/functions/index',
      getPagedList: '/api/functions/list',
      getAll: '/api/functions/getAll',
      getListFunctionsTree: '/api/functions/tree',
      create: '/api/functions/create',
      update: '/api/functions/update',
      getById: '/api/functions/getById',
      delete: '/api/functions/delete',
      import: '/api/functions/import',
    },
    roles: {
      index: '/api/roles/index',
      getPagedList: '/api/roles/list',
      getById: '/api/roles/getById',
      getAll: '/api/roles/getAll',
      create: '/api/roles/create',
      update: '/api/roles/update',
      delete: '/api/roles/delete',
      import: '/api/roles/import',
    },
    nhanvien: {
      index: '/api/nhanvien/index',
      getPagedList: '/api/nhanvien/list',
      getPagedListWarning: '/api/nhanvien/warning',
      getById: '/api/nhanvien/getById',
      getView: '/api/nhanvien/view',
      create: '/api/nhanvien/create',
      uploadImage: '/api/nhanvien/image/upload',
      getImage: '/api/nhanvien/image/download',
      update: '/api/nhanvien/update',
      updateTrangThai: '/api/nhanvien/update/status',
      delete: '/api/nhanvien/delete',
      detail: '/api/nhanvien/detail',
      upload: '/api/nhanvien/upload',
      download: '/api/nhanvien/download',
      export: '/api/nhanvien/export',
      report: '/api/nhanvien/report',
      import: '/api/nhanvien/import',
      saveImport: '/api/nhanvien/import/save',
      getTemplate: '/api/nhanvien/import/template',
      exportBySheet: '/api/nhanvien/export-by-sheet',
      exportById: '/api/nhanvien/exportById',
      getListSelectNhanVien: '/api/nhanvien/getListSelectNhanVien',
      getListWarning: '/api/nhanvien/warning/noti',
      payrollSummary: '/api/nhanvien/detail/payrollSummary',

    },
    dmQuanHe: {
      index: '/api/quanhe/index',
      getPagedList: '/api/quanhe/list',
      getById: '/api/quanhe/getById',
      getAll: '/api/quanhe/getAll',
      create: '/api/quanhe/create',
      update: '/api/quanhe/update',
      delete: '/api/quanhe/delete',
      import: '/api/quanhe/import',
    },
    thamSoKyHieuCong: {
      index: '/api/thamsokyhieucong/index',
      getPagedList: '/api/thamsokyhieucong/list',
      getById: '/api/thamsokyhieucong/getById',
      getAll: '/api/thamsokyhieucong/getAll',
      create: '/api/thamsokyhieucong/create',
      update: '/api/thamsokyhieucong/update',
      delete: '/api/thamsokyhieucong/delete',
    },
    configLuongGio: {
      index: '/api/configluonggio/index',
      getPagedList: '/api/configluonggio/list',
      getById: '/api/configluonggio/getById',
      getAll: '/api/configluonggio/getAll',
      create: '/api/configluonggio/create',
      update: '/api/configluonggio/update',
      delete: '/api/configluonggio/delete',
    },
    nhomKyHieuCong: {
      index: '/api/nhomkyhieucong/index',
      getPagedList: '/api/nhomkyhieucong/list',
      getById: '/api/nhomkyhieucong/getById',
      getAll: '/api/nhomkyhieucong/getAll',
      create: '/api/nhomkyhieucong/create',
      update: '/api/nhomkyhieucong/update',
      delete: '/api/nhomkyhieucong/delete',
    },
    dmLoaiPhuCap: {
      index: '/api/loaiphucap/index',
      getPagedList: '/api/loaiphucap/list',
      getById: '/api/loaiphucap/getById',
      getAll: '/api/loaiphucap/getAll',
      create: '/api/loaiphucap/create',
      update: '/api/loaiphucap/update',
      delete: '/api/loaiphucap/delete',
    },
    dmPhuCap: {
      index: '/api/phucap/index',
      getPagedList: '/api/phucap/list',
      getById: '/api/phucap/getById',
      getAll: '/api/phucap/getAll',
      create: '/api/phucap/create',
      update: '/api/phucap/update',
      delete: '/api/phucap/delete',
      export: '/api/phucap/export',
      import: '/api/phucap/import',
      saveImport: '/api/phucap/import/save',
      getTemplate: '/api/phucap/import/template',
    },
    configLuong: {
      getConfig: '/api/configluong/getConfig',
      update: '/api/configluong/update',
    },
    dmLuong: {
      index: '/api/phieuluong/index',
      getPagedList: '/api/phieuluong/list',
      getById: '/api/phieuluong/getById',
      getAll: '/api/phieuluong/getAll',
      create: '/api/phieuluong/create',
      update: '/api/phieuluong/update',
      delete: '/api/phieuluong/delete',
      detail: '/api/phieuluong/detail',
      export: '/api/phieuluong/export',
      import: '/api/phieuluong/import',
      saveImport: '/api/phieuluong/import/save',
      getTemplate: '/api/phieuluong/import/template',
      payrollSummary: '/api/phieuluong/payrollSummary'
    },
    quanLyCong: {
      index: '/api/quanlycong/index',
      getPagedList: '/api/quanlycong/list',
      getById: '/api/quanlycong/getById',
      delete: '/api/quanlycong/delete',
      detail: '/api/quanlycong/detail',
      import: '/api/quanlycong/import',
      export: '/api/quanlycong/export',
      exportByDonVi: '/api/quanlycong/exportByDonVi',
      approve: '/api/quanlycong/approve',
      reject: '/api/quanlycong/reject',
      salaryApprove: '/api/quanlycong/salary/approve',
      salarySupplementaryApprove: '/api/quanlycong/salary/supplenmentary/approve',
      salaryReject: '/api/quanlycong/salary/reject',
      salaryRevert: '/api/quanlycong/salary/revert',
      saveImport: '/api/quanlycong/import/save',
      getTemplate: '/api/quanlycong/import/template'
    },
    quanLyThuNhap: {
      index: '/api/quanlythunhap/index',
      getPagedList: '/api/quanlythunhap/list',
      export: '/api/quanlythunhap/export'
    },
    quanLyAnCa: {
      index: '/api/quanlyanca/index'
    },
    dmLuongCapBac: {
      index: '/api/luongcapbac/index',
      getPagedList: '/api/luongcapbac/list',
      getById: '/api/luongcapbac/getById',
      getAll: '/api/luongcapbac/getAll',
      create: '/api/luongcapbac/create',
      update: '/api/luongcapbac/update',
      delete: '/api/luongcapbac/delete',
      detail: '/api/luongcapbac/detail',
      export: '/api/luongcapbac/export',
      import: '/api/luongcapbac/import',
      saveImport: '/api/luongcapbac/import/save',
      getTemplate: '/api/luongcapbac/import/template',
    },
    dmLuongNangSuat: {
      index: '/api/luongnangsuat/index',
      getPagedList: '/api/luongnangsuat/list',
      getById: '/api/luongnangsuat/getById',
      getAll: '/api/luongnangsuat/getAll',
      create: '/api/luongnangsuat/create',
      update: '/api/luongnangsuat/update',
      delete: '/api/luongnangsuat/delete',
      detail: '/api/luongnangsuat/detail',
      export: '/api/luongnangsuat/export',
      import: '/api/luongnangsuat/import',
      saveImport: '/api/luongnangsuat/import/save',
      getTemplate: '/api/luongnangsuat/import/template',
    },
    dmDonVi: {
      index: '/api/donvi/index',
      getPagedList: '/api/donvi/list',
      getById: '/api/donvi/getById',
      getAll: '/api/donvi/getAll',
      create: '/api/donvi/create',
      update: '/api/donvi/update',
      delete: '/api/donvi/delete',
      import: '/api/donvi/import',
    },
    templateLuong: {
      index: '/api/templateluong/index',
      getPagedList: '/api/templateluong/list',
      getById: '/api/templateluong/getById',
      getAll: '/api/templateluong/getAll',
      create: '/api/templateluong/create',
      update: '/api/templateluong/update',
      delete: '/api/templateluong/delete',
    },
    nangDinh: {
      index: '/api/nangdinh/index',
      getPagedList: '/api/nangdinh/list',
      getById: '/api/nangdinh/getById',
      getAll: '/api/nangdinh/getAll',
      create: '/api/nangdinh/create',
      update: '/api/nangdinh/update',
      delete: '/api/nangdinh/delete',
      getDetail: '/api/nangdinh/detail',
      export: '/api/nangdinh/export',
      import: '/api/nangdinh/import',
      saveImport: '/api/nangdinh/import/save',
      getTemplate: '/api/nangdinh/import/template',
    },
    nhanXetHangNam: {
      index: '/api/nhanxethangnam/index',
      getPagedList: '/api/nhanxethangnam/list',
      getById: '/api/nhanxethangnam/getById',
      getAll: '/api/nhanxethangnam/getAll',
      create: '/api/nhanxethangnam/create',
      update: '/api/nhanxethangnam/update',
      delete: '/api/nhanxethangnam/delete',
      import: '/api/nhanxethangnam/import',
      export: '/api/nhanxethangnam/export',
      detail: '/api/nhanxethangnam/detail',
      saveImport: '/api/nhanxethangnam/import/save',
      getTemplate: '/api/nhanxethangnam/import/template',
    },
    nhanXetHangNamDang: {
      index: '/api/nxdang/index',
      getPagedList: '/api/nxdang/list',
      getById: '/api/nxdang/getById',
      getAll: '/api/nxdang/getAll',
      create: '/api/nxdang/create',
      update: '/api/nxdang/update',
      delete: '/api/nxdang/delete',
      import: '/api/nxdang/import',
      export: '/api/nxdang/export',
      detail: '/api/nxdang/detail',
      saveImport: '/api/nxdang/import/save',
      getTemplate: '/api/nxdang/import/template',
    },
    nhanXetHangNamCongDoan: {
      index: '/api/nxcongdoan/index',
      getPagedList: '/api/nxcongdoan/list',
      getById: '/api/nxcongdoan/getById',
      getAll: '/api/nxcongdoan/getAll',
      create: '/api/nxcongdoan/create',
      update: '/api/nxcongdoan/update',
      delete: '/api/nxcongdoan/delete',
      import: '/api/nxcongdoan/import',
      export: '/api/nxcongdoan/export',
      detail: '/api/nxcongdoan/detail',
      saveImport: '/api/nxcongdoan/import/save',
      getTemplate: '/api/nxcongdoan/import/template',
    },
    nhanXetHangNamDoanThanhNien: {
      index: '/api/nxdoanthanhnien/index',
      getPagedList: '/api/nxdoanthanhnien/list',
      getById: '/api/nxdoanthanhnien/getById',
      getAll: '/api/nxdoanthanhnien/getAll',
      create: '/api/nxdoanthanhnien/create',
      update: '/api/nxdoanthanhnien/update',
      delete: '/api/nxdoanthanhnien/delete',
      import: '/api/nxdoanthanhnien/import',
      export: '/api/nxdoanthanhnien/export',
      detail: '/api/nxdoanthanhnien/detail',
      saveImport: '/api/nxdoanthanhnien/import/save',
      getTemplate: '/api/nxdoanthanhnien/import/template',
    },
    khenThuong: {
      index: '/api/khenthuong/index',
      getPagedList: '/api/khenthuong/list',
      getById: '/api/khenthuong/getById',
      getAll: '/api/khenthuong/getAll',
      create: '/api/khenthuong/create',
      update: '/api/khenthuong/update',
      delete: '/api/khenthuong/delete',
      detail: '/api/khenthuong/detail',
      export: '/api/khenthuong/export',
      import: '/api/khenthuong/import',
      saveImport: '/api/khenthuong/import/save',
      getTemplate: '/api/khenthuong/import/template',
    },
    khenThuongDang: {
      index: '/api/ktdang/index',
      getPagedList: '/api/ktdang/list',
      getById: '/api/ktdang/getById',
      getAll: '/api/ktdang/getAll',
      create: '/api/ktdang/create',
      update: '/api/ktdang/update',
      delete: '/api/ktdang/delete',
      detail: '/api/ktdang/detail',
      export: '/api/ktdang/export',
      import: '/api/ktdang/import',
      saveImport: '/api/ktdang/import/save',
      getTemplate: '/api/ktdang/import/template',
    },
    khenThuongCongDoan: {
      index: '/api/ktcongdoan/index',
      getPagedList: '/api/ktcongdoan/list',
      getById: '/api/ktcongdoan/getById',
      getAll: '/api/ktcongdoan/getAll',
      create: '/api/ktcongdoan/create',
      update: '/api/ktcongdoan/update',
      delete: '/api/ktcongdoan/delete',
      detail: '/api/ktcongdoan/detail',
      export: '/api/ktcongdoan/export',
      import: '/api/ktcongdoan/import',
      saveImport: '/api/ktcongdoan/import/save',
      getTemplate: '/api/ktcongdoan/import/template',
    },
    khenThuongDoanThanhNien: {
      index: '/api/ktdoanthanhnien/index',
      getPagedList: '/api/ktdoanthanhnien/list',
      getById: '/api/ktdoanthanhnien/getById',
      getAll: '/api/ktdoanthanhnien/getAll',
      create: '/api/ktdoanthanhnien/create',
      update: '/api/ktdoanthanhnien/update',
      delete: '/api/ktdoanthanhnien/delete',
      detail: '/api/ktdoanthanhnien/detail',
      export: '/api/ktdoanthanhnien/export',
      import: '/api/ktdoanthanhnien/import',
      saveImport: '/api/ktdoanthanhnien/import/save',
      getTemplate: '/api/ktdoanthanhnien/import/template',
    },
    kyLuat: {
      index: '/api/kyluat/index',
      getPagedList: '/api/kyluat/list',
      getById: '/api/kyluat/getById',
      getAll: '/api/kyluat/getAll',
      create: '/api/kyluat/create',
      update: '/api/kyluat/update',
      delete: '/api/kyluat/delete',
      detail: '/api/kyluat/detail',
      export: '/api/kyluat/export',
      import: '/api/kyluat/import',
      saveImport: '/api/kyluat/import/save',
      getTemplate: '/api/kyluat/import/template',
    },
    kyLuatDang: {
      index: '/api/kldang/index',
      getPagedList: '/api/kldang/list',
      getById: '/api/kldang/getById',
      getAll: '/api/kldang/getAll',
      create: '/api/kldang/create',
      update: '/api/kldang/update',
      delete: '/api/kldang/delete',
      detail: '/api/kldang/detail',
      export: '/api/kldang/export',
      import: '/api/kldang/import',
      saveImport: '/api/kldang/import/save',
      getTemplate: '/api/kldang/import/template',
    },
    kyLuatCongDoan: {
      index: '/api/klcongdoan/index',
      getPagedList: '/api/klcongdoan/list',
      getById: '/api/klcongdoan/getById',
      getAll: '/api/klcongdoan/getAll',
      create: '/api/klcongdoan/create',
      update: '/api/klcongdoan/update',
      delete: '/api/klcongdoan/delete',
      detail: '/api/klcongdoan/detail',
      export: '/api/klcongdoan/export',
      import: '/api/klcongdoan/import',
      saveImport: '/api/klcongdoan/import/save',
      getTemplate: '/api/klcongdoan/import/template',
    },
    kyLuatDoanThanhNien: {
      index: '/api/kldoanthanhnien/index',
      getPagedList: '/api/kldoanthanhnien/list',
      getById: '/api/kldoanthanhnien/getById',
      getAll: '/api/kldoanthanhnien/getAll',
      create: '/api/kldoanthanhnien/create',
      update: '/api/kldoanthanhnien/update',
      delete: '/api/kldoanthanhnien/delete',
      detail: '/api/kldoanthanhnien/detail',
      export: '/api/kldoanthanhnien/export',
      import: '/api/kldoanthanhnien/import',
      saveImport: '/api/kldoanthanhnien/import/save',
      getTemplate: '/api/kldoanthanhnien/import/template',
    },
    qtctDang: {
      index: '/api/qtctdang/index',
      getPagedList: '/api/qtctdang/list',
      getById: '/api/qtctdang/getById',
      getAll: '/api/qtctdang/getAll',
      create: '/api/qtctdang/create',
      update: '/api/qtctdang/update',
      delete: '/api/qtctdang/delete',
      detail: '/api/qtctdang/detail',
      export: '/api/qtctdang/export',
      import: '/api/qtctdang/import',
      saveImport: '/api/qtctdang/import/save',
      getTemplate: '/api/qtctdang/import/template',
    },
    hopDongLaoDong: {
      index: '/api/hopdonglaodong/index',
      getPagedList: '/api/hopdonglaodong/list',
      getById: '/api/hopdonglaodong/getById',
      getAll: '/api/hopdonglaodong/getAll',
      create: '/api/hopdonglaodong/create',
      update: '/api/hopdonglaodong/update',
      delete: '/api/hopdonglaodong/delete',
      detail: '/api/hopdonglaodong/detail',
      export: '/api/hopdonglaodong/export',
      import: '/api/hopdonglaodong/import',
      saveImport: '/api/hopdonglaodong/import/save',
      getTemplate: '/api/hopdonglaodong/import/template',
      importFile: '/api/hopdonglaodong/import/file',
      downloadTemplate: '/api/hopdonglaodong/template/download',
    },
    qtctCongDoan: {
      index: '/api/qtctcongdoan/index',
      getPagedList: '/api/qtctcongdoan/list',
      getById: '/api/qtctcongdoan/getById',
      getAll: '/api/qtctcongdoan/getAll',
      create: '/api/qtctcongdoan/create',
      update: '/api/qtctcongdoan/update',
      delete: '/api/qtctcongdoan/delete',
      detail: '/api/qtctcongdoan/detail',
      export: '/api/qtctcongdoan/export',
      import: '/api/qtctcongdoan/import',
      saveImport: '/api/qtctcongdoan/import/save',
      getTemplate: '/api/qtctcongdoan/import/template',
    },
    qtctDoanThanhNien: {
      index: '/api/qtctdoanthanhnien/index',
      getPagedList: '/api/qtctdoanthanhnien/list',
      getById: '/api/qtctdoanthanhnien/getById',
      getAll: '/api/qtctdoanthanhnien/getAll',
      create: '/api/qtctdoanthanhnien/create',
      update: '/api/qtctdoanthanhnien/update',
      delete: '/api/qtctdoanthanhnien/delete',
      detail: '/api/qtctdoanthanhnien/detail',
      export: '/api/qtctdoanthanhnien/export',
      import: '/api/qtctdoanthanhnien/import',
      saveImport: '/api/qtctdoanthanhnien/import/save',
      getTemplate: '/api/qtctdoanthanhnien/import/template',
    },
    baohiem: {
      index: '/api/baohiem/index',
      getById: '/api/baohiem/getById',
      update: '/api/baohiem/update',
      detail: '/api/baohiem/detail',
      export: '/api/baohiem/export',
      import: '/api/baohiem/import',
      saveImport: '/api/baohiem/import/save',
      getTemplate: '/api/baohiem/import/template',
    },
    thuetncn: {
      index: '/api/thuetncn/index',
      getById: '/api/thuetncn/getById',
      update: '/api/thuetncn/update',
      detail: '/api/thuetncn/detail',
      export: '/api/thuetncn/export',
      import: '/api/thuetncn/import',
      saveImport: '/api/thuetncn/import/save',
      getTemplate: '/api/thuetncn/import/template',
    },
    dmTaiLieu: {
      index: '/api/tailieu/index',
      create: '/api/tailieu/create',
      update: '/api/tailieu/update',
      delete: '/api/tailieu/delete',
      download: '/api/tailieu/download',
    },
    daoTaoHuanLuyen: {
      index: '/api/daotaohuanluyen/index',
      create: '/api/daotaohuanluyen/create',
      update: '/api/daotaohuanluyen/update',
      delete: '/api/daotaohuanluyen/delete',
      getPagedList: '/api/daotaohuanluyen/list',
      getById: '/api/daotaohuanluyen/getById',
      getDetail: '/api/daotaohuanluyen/detail',
      export: '/api/daotaohuanluyen/export',
      import: '/api/daotaohuanluyen/import',
      saveImport: '/api/daotaohuanluyen/import/save',
      getTemplate: '/api/daotaohuanluyen/import/template',
    },
    caLamViec: {
      index: '/api/calamviec/index',
      create: '/api/calamviec/create',
      update: '/api/calamviec/update',
      delete: '/api/calamviec/delete',
      getPagedList: '/api/calamviec/list',
      getById: '/api/calamviec/getById',
      getDetail: '/api/calamviec/detail',
      export: '/api/calamviec/export',
      import: '/api/calamviec/import',
      saveImport: '/api/calamviec/import/save',
      getTemplate: '/api/calamviec/import/template',
    },
    logs: {
      index: '/api/logs/index',
      getPagedList: '/api/logs/list',
      delete: '/api/logs/delete',
    },
    dashboard: {
      getDashboardList: '/api/dashboard/getDashboard',
      getEmployeeBirthday: '/api/dashboard/getEmployeeBirthday',
    }
  };
}
